// shared/utils/roles.ts

export enum Role {
  SuperAdmin = 'BPM_SuperAdmins',
  Admin = 'BPM_Admins',
  Editor = 'BPM_Editors',
  Author = 'BPM_Authors'
}

export const SUPER_USER_EMAIL = 'mstringham@gmail.com'

export function isSuperUser(
  roles: string | string[] | null | undefined,
  email?: string | null
): boolean {
  const list = Array.isArray(roles) ? roles : roles ? [roles] : []
  return list.includes(Role.SuperAdmin) || (email || '').toLowerCase() === SUPER_USER_EMAIL
}